module.exports = __webpack_public_path__ + "img/end_title2.118dafea.png";